import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Slide,
  Typography,
} from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./Style.module.css";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DialogWrapper = ({ open, onClose, title, children, maxWidth = "xl" }) => {
  return (
    <Dialog
      fullWidth
      maxWidth={maxWidth}
      keepMounted
      TransitionComponent={Transition}
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: { borderRadius: 2 },
      }}
    >
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", }}>
        <div>
          <Typography variant="h5" className={styles.title}>
            Expanded View
          </Typography>
          <div className={styles.newLine}></div>
        </div>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 0 }}>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default DialogWrapper;
